const accessKeysNL = {
    "view": {
        "title": "Toegangssleutels",
        "form": {
            "label": {
                "accessKeyId": "Toegangssleutel-ID",
                "secretAccessKey": "Geheime toegangssleutel"
            },
            "button": {
                "hide": "Verbergen",
                "reveal": "Onthullen"
            },
            "message": {
                "accessKeyIdCopied": "Toegangssleutel-ID gekopieerd naar klembord!",
                "secretAccessKeyCopied": "Geheime toegangssleutel gekopieerd naar klembord!"
            }
        },
        "uploadInstructions": {
            "title": "Instructies",
            "step1": {
                "title": "Stap 1 - Download upload tool",
                "description": "Download de <1>Cyberduck</1> tool."
            },
            "step2": {
                "title": "Stap 2 - Maak een kopie van Upload Spreadsheet en sla het Trigger-bestand op",
                "descriptionPoint1": "Kopieer deze <1><strong>SPREADSHEET</strong></1> naar je GOOGLE DRIVE.",
                "descriptionPoint2": "Sla dit <1><strong>TRIGGER BESTAND</strong></1> op je computer of cloudopslag op."
            },
            "step3": {
                "title": "Stap 3 - Maak de verbinding",
                "descriptionPoint1": "Open de Cyberduck tool.",
                "descriptionPoint2": "Klik in de linkerbenedenhoek op het + icoon. (Nieuwe bladwijzer toevoegen).",
                "descriptionPoint3": "Voer de volgende inloggegevens in:",
                "descriptionPoint4": "Toegangssleutel-ID: ",
                "descriptionPoint5": "Geheime toegangssleutel: ",
                "descriptionPoint6": "Je S3-map: ",
                "descriptionPoint7": "Je S3-pad: ",
                "descriptionPoint8": "Volg deze stappen:"
            },
            "step4": {
                "title": "Stap 4 - Vul de metadata in",
                "description": "Vul de metadata in volgens de instructies van ons Helpcentrum."
            },
            "step5": {
                "title": "Stap 5 - Bestanden en Genres",
                "descriptionPoint1": "Upload je <1>metadata.csv</1> bestand en alle audio <3>(.wav)</3> en <5>afbeelding (.jpg)</5> bestanden, <7> NIET (.jpeg)</7>",
                "descriptionPoint2": "<strong>JPG-bestanden</strong> moeten <strong>3000x3000 px, max bestandsgrootte 4MB</strong> zijn",
                "descriptionPoint3": "Audiobestanden moeten alleen <strong>wav, 16 bit, 44.1 khz</strong> zijn",
                "descriptionPoint4": "Root bestandsnamen moeten één woord zijn",
                "descriptionPoint5": "<strong>BELANGRIJK:</strong> Let op <2><strong>ML Dance Genres</strong></2> en overeenkomsten in de winkels zoals Beatport."
            },
            "step6": {
                "title": "Stap 6 - Upload Trigger",
                "description": "Nadat alle bestanden zijn geüpload, upload dan dit lege trigger-bestand <1>“last.zzz”</1>. Houd je e-mail in de gaten voor eventuele meldingen."
            },
            "step7": {
                "title": "Advies - Test met ons voordat je uploadt",
                "description": "Neem gerust contact op met ons ondersteuningsteam voor vragen over deze manier van releasecreatie. Dit is een zeer eenvoudig proces dat vertrouwt op robuustere technologieën zoals AWS S3 en niet op browsertechnologieën. Het vereist echter dat je metadata 100% nauwkeurig is. Het Music Link-team kan een paar releases voor je testen met je metadata om mogelijke problemen te detecteren."
            }
        }
    }
};

export default accessKeysNL;